import { useEffect } from 'react';

import { MixpanelEvent, trackEvent } from '../utils/mx';

export const useScreenView = (eventName: MixpanelEvent) => {
  useEffect(() => {
    trackEvent(eventName);
  }, [eventName]);
};
